export const UTM_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_id",
] as const;

export type UtmParamKey = (typeof UTM_PARAM_KEYS)[number];
export type UtmParams = Partial<Record<UtmParamKey, string>>;

export const normalizeUtmParams = (values: Partial<Record<string, unknown>>): UtmParams | null => {
  const utmParams: UtmParams = {};

  for (const key of UTM_PARAM_KEYS) {
    const value = values[key];

    if (typeof value === "string" && value.length > 0) {
      utmParams[key] = value;
    }
  }

  return Object.keys(utmParams).length > 0 ? utmParams : null;
};
